

export function excelColumnToIndex(column: string): number {
    if (!/^[A-Z]+$/.test(column)) {
        throw new Error(`Invalid Excel column: ${column}. Expected format is 'A', 'B', ...`);
    }
    let index = 0;
    for (let i = 0; i < column.length; i++) {
        index *= 26;
        index += column.charCodeAt(i) - 'A'.charCodeAt(0) + 1;
    }

    const result = index - 1; // Convert to 0-based index
    if (result < 0) {
        throw new Error(`Invalid Excel column: ${column}. Resulting index is negative.`);
    }
    return result;
}

export function excelIndexToColumn(index: number): string {
    let column = '';
    index++; // Convert to 1-based index
    while (index > 0) {
        const remainder = (index - 1) % 26;
        column = String.fromCharCode(remainder + 'A'.charCodeAt(0)) + column;
        index = Math.floor((index - 1) / 26);
    }
    return column;
}


export function excelCoordsToIndexes(coords: string): { row: number; column: number } {
    const match = coords.match(/^([A-Z]+)(\d+)$/);
    if (!match) {
        throw new Error(`Invalid Excel coordinates: ${coords}. Expected format is 'A1', 'B2'...`);
    }
    const column = excelColumnToIndex(match[1]);
    const row = parseInt(match[2], 10) - 1; // Convert to 0-based index
    if (isNaN(row) || row < 0) {
        throw new Error(`Invalid row number in coordinates: ${coords}. Row must be a positive integer.`);
    }
    return { row, column };
}

export function indexesToExcelCoords(row: number, column: number): string {
    const colStr = excelIndexToColumn(column);
    return `${colStr}${row + 1}`; // Convert to 1-based index for Excel
}
